import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/react';
import {
  Container,
  Title,
  Alert,
  Text,
  Loader
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import ProductManagement from '../../components/seller/ProductManagement';
import { useApi, useSession } from '../../api';

const SellerProducts = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const { isSeller, status } = useSession();

  const {
    data: sellerProfile,
    loading,
    error
  } = useApi('/api/v1/me/seller', undefined, { enabled: isSignedIn && isSeller });

  // Wait for auth state to settle (Clerk loaded + session role known) before
  // redirecting — otherwise signed-in sellers deep-linking here bounce home.
  if (!isLoaded || status === 'connecting') {
    return (
      <Container size="xl" py="xl">
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader size="lg" />
        </div>
      </Container>
    );
  }

  // Redirect if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  // Show message if not a seller
  if (!isSeller) {
    return (
      <Container size="lg" py="xl">
        <Alert
          icon={<IconExclamationCircle size="1rem" />}
          color="pink"
          title="Princess Access Required"
        >
          <Text>
            You need to be a registered princess to access this page.
            Please register as a princess first to start listing products.
          </Text>
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container size="xl" py="xl">
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader size="lg" />
        </div>
      </Container>
    );
  }

  const canSell = !!sellerProfile
    && sellerProfile.seller_status === 'approved'
    && sellerProfile.is_verified
    && sellerProfile.is_active_seller !== false;

  return (
    <Container size="xl" py="xl">
      <Title order={1} mb="xl">My Products</Title>

      {error && (
        <Alert
          icon={<IconExclamationCircle size="1rem" />}
          color="red"
          mb="xl"
        >
          {error.message}
        </Alert>
      )}

      {sellerProfile && (
        <ProductManagement canSell={canSell} />
      )}
    </Container>
  );
};

export default SellerProducts;
